import Head from "next/head";
import { useRouter } from "next/router";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import Header from "../../components/common/Header";
import CommonBanner2 from "../../components/common/CommonBanner2";
import CareerDetails from "../../components/career-details";
import CareerForm from "../../components/careers-form";
import Footer from "../../components/footer";
import { fetchCareersDetails } from "../../components/http/commonApi";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import HreflangLinks from "../../components/common/HrefLinkTags";
import { useTranslation } from "next-i18next";

const CareerDetailPage = ({ careerDetails, locale }) => {
  const { t } = useTranslation("careers");
  const router = useRouter();

  if (router.isFallback) {
    return <LoadingSpinner message="Loading career details..." />;
  }

  if (!careerDetails) {
    return <div className="p-10 text-xl">career not found.</div>;
  }

  return (
    <>
      {/* <HreflangLinks
        enPath={`/careers/${careerDetails?.slug}`}
        arPath={`/careers/${careerDetails?.slug}`}
      /> */}

      <HreflangLinks
        enPath={`/careers/${careerDetails?.slug}`}
        arPath={
          careerDetails?.hasArabic ? `/ar/careers/${careerDetails.slug}` : null
        }
      />

      <Head>
        <title>
          {careerDetails?.metaTitle ||
            "Prism Digital | Top Digital Marketing Agency in UAE"}
        </title>
        <meta
          name="description"
          content={
            careerDetails?.metaDescription ||
            "A leading digital marketing agency in UAE - Prism Digital, offering SEO, PPC, social media, and web design services to grow your brand online. Book us today!"
          }
        />
        {locale === "ar" ? (
          <link
            rel="canonical"
            href={`https://www.prism-me.com/${locale}/careers/${careerDetails?.slug}`}
          />
        ) : (
          <link
            rel="canonical"
            href={`https://www.prism-me.com/careers/${careerDetails?.slug}`}
          />
        )}
      </Head>
      <Header />
      <main className="w-full box-border bg-background-color-primary overflow-hidden">
        {/* <CommonBanner2 name={careerDetails?.position} /> */}

        <CommonBanner2
          name={careerDetails?.position}
          breadcrumbProps={{
            labelMap: {
              home: locale === "ar" ? "الرئيسية" : "Home",
              careers: locale === "ar" ? "الوظائف" : "Careers",
            },
            dynamicLabel: careerDetails?.position,
            separator: locale === "ar" ? "‹" : ">",
          }}
        />

        <CareerDetails
          overview={careerDetails?.overview}
          qualifications={careerDetails?.qualifications}
          keyResponsibilities={careerDetails?.keyResponsibilities}
          benefits={careerDetails?.benefits}
        />
        <CareerForm careerId={careerDetails?._id} />
      </main>
      <Footer />
    </>
  );
};

export default CareerDetailPage;

// ✅ Static Paths

export async function getServerSideProps({ params, locale, res }) {
  try {
    const { data } = await fetchCareersDetails(params.slug, locale);

    // Your API sometimes returns: { error: "Career not found" }
    if (!data || data?.error === "Career not found") {
      return {
        redirect: {
          destination: locale === "ar" ? "/ar/careers" : "/careers",
          permanent: false, // keep false unless you are 100% sure it will never exist
        },
      };
    }

    // cache headers (only for valid pages)
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=60, stale-while-revalidate=300",
    );

    return {
      props: {
        careerDetails: data,
        locale,
        ...(await serverSideTranslations(locale, [
          "header",
          "footer",
          "careers",
          "common",
        ])),
      },
    };
  } catch (error) {
    // if axios gives 404, redirect as well
    const status = error?.response?.status;
    const apiMsg = error?.response?.data?.error;

    if (status === 404 || apiMsg === "Career not found") {
      return {
        redirect: {
          destination: locale === "ar" ? "/ar/careers" : "/careers",
          permanent: false,
        },
      };
    }

    // for real server errors, keep notFound or show 500
    return { notFound: true };
  }
}
